var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionalSplitPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 79,
    viewBox: "0 0 72 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.9412,
    y: 6,
    width: 48,
    height: 48,
    rx: 5,
    transform: "rotate(45 37.9412 6)",
    fill: "#00C6A2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 26,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 28,
    height: 28,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.226 29.774C48.3969 29.9448 48.3969 30.2218 48.226 30.3927L44.726 33.8927C44.5552 34.0635 44.2782 34.0635 44.1073 33.8927C43.9365 33.7218 43.9365 33.4448 44.1073 33.274L47.6073 29.774C47.7782 29.6031 48.0552 29.6031 48.226 29.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.826 29.7193C32.0271 29.8533 32.0814 30.125 31.9474 30.326L29.614 33.826C29.5497 33.9226 29.4496 33.9896 29.3358 34.0123C29.222 34.0351 29.1039 34.0117 29.0073 33.9474L27.2573 32.7807C27.0563 32.6467 27.0019 32.375 27.136 32.174C27.27 31.9729 27.5416 31.9186 27.7427 32.0526L29.1287 32.9766L31.2193 29.8407C31.3533 29.6396 31.625 29.5853 31.826 29.7193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1074 29.774C44.2783 29.6031 44.5553 29.6031 44.7261 29.774L48.226 33.274C48.3969 33.4448 48.3969 33.7218 48.226 33.8927C48.0552 34.0635 47.7782 34.0635 47.6073 33.8927L44.1074 30.3927C43.9366 30.2218 43.9366 29.9448 44.1074 29.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.894 51.6667C38.2454 51.6667 38.5303 51.3818 38.5303 51.0303C38.5303 50.6789 38.2454 50.3939 37.894 50.3939C37.5425 50.3939 37.2576 50.6789 37.2576 51.0303C37.2576 51.3818 37.5425 51.6667 37.894 51.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8944 44.6667C36.7716 44.6667 35.8581 45.5802 35.8581 46.703C35.8581 46.9842 36.086 47.2121 36.3672 47.2121C36.6483 47.2121 36.8763 46.9842 36.8763 46.703C36.8763 46.1416 37.333 45.6848 37.8944 45.6848C38.4559 45.6848 38.9126 46.1416 38.9126 46.703C38.9126 47.2645 38.4559 47.7212 37.8944 47.7212C37.6133 47.7212 37.3853 47.9491 37.3853 48.2303V49.503C37.3853 49.7842 37.6133 50.0121 37.8944 50.0121C38.1756 50.0121 38.4035 49.7842 38.4035 49.503V48.675C39.2808 48.4483 39.9308 47.6502 39.9308 46.703C39.9308 45.5802 39.0173 44.6667 37.8944 44.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0833 43.2083H33.9167C33.4334 43.2083 33.0417 43.6001 33.0417 44.0833V52.25C33.0417 52.7332 33.4334 53.125 33.9167 53.125H42.0833C42.5666 53.125 42.9583 52.7332 42.9583 52.25V44.0833C42.9583 43.6001 42.5666 43.2083 42.0833 43.2083ZM33.9167 42.3333C32.9502 42.3333 32.1667 43.1168 32.1667 44.0833V52.25C32.1667 53.2165 32.9502 54 33.9167 54H42.0833C43.0498 54 43.8333 53.2165 43.8333 52.25V44.0833C43.8333 43.1168 43.0498 42.3333 42.0833 42.3333H33.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8333 36.7917C32.5717 36.7917 34.7917 34.5717 34.7917 31.8333C34.7917 29.0949 32.5717 26.875 29.8333 26.875C27.0949 26.875 24.875 29.0949 24.875 31.8333C24.875 34.5717 27.0949 36.7917 29.8333 36.7917ZM29.8333 37.6667C33.055 37.6667 35.6667 35.055 35.6667 31.8333C35.6667 28.6117 33.055 26 29.8333 26C26.6117 26 24 28.6117 24 31.8333C24 35.055 26.6117 37.6667 29.8333 37.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1667 36.7917C48.9051 36.7917 51.125 34.5717 51.125 31.8333C51.125 29.0949 48.9051 26.875 46.1667 26.875C43.4283 26.875 41.2083 29.0949 41.2083 31.8333C41.2083 34.5717 43.4283 36.7917 46.1667 36.7917ZM46.1667 37.6667C49.3883 37.6667 52 35.055 52 31.8333C52 28.6117 49.3883 26 46.1667 26C42.945 26 40.3333 28.6117 40.3333 31.8333C40.3333 35.055 42.945 37.6667 46.1667 37.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8333 36.8608C30.075 36.8608 30.2708 36.8417 30.2708 37.0833V38.9792H45.7292V37.0833C45.7292 36.8417 46.0709 36.9375 46.3125 36.9375C46.5541 36.9375 46.6042 36.8417 46.6042 37.0833V39.4167C46.6042 39.6583 46.4083 39.8542 46.1667 39.8542H38.4375V42.3333C38.4375 42.575 38.2416 42.7708 38 42.7708C37.7584 42.7708 37.5625 42.575 37.5625 42.3333V39.8542H29.8333C29.5917 39.8542 29.3958 39.6583 29.3958 39.4167V37.0833C29.3958 36.8417 29.5917 36.8608 29.8333 36.8608Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 73C44 76.3137 41.3137 79 38 79C34.6863 79 32 76.3137 32 73C32 69.6863 34.6863 67 38 67C41.3137 67 44 69.6863 44 73Z",
    fill: "#9088DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 78C40.7614 78 43 75.7614 43 73C43 70.2386 40.7614 68 38 68C35.2386 68 33 70.2386 33 73C33 75.7614 35.2386 78 38 78ZM38 79C41.3137 79 44 76.3137 44 73C44 69.6863 41.3137 67 38 67C34.6863 67 32 69.6863 32 73C32 76.3137 34.6863 79 38 79Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 6C44 9.31371 41.3137 12 38 12C34.6863 12 32 9.31371 32 6C32 2.68629 34.6863 0 38 0C41.3137 0 44 2.68629 44 6Z",
    fill: "#9088DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 11C40.7614 11 43 8.76142 43 6C43 3.23858 40.7614 1 38 1C35.2386 1 33 3.23858 33 6C33 8.76142 35.2386 11 38 11ZM38 12C41.3137 12 44 9.31371 44 6C44 2.68629 41.3137 0 38 0C34.6863 0 32 2.68629 32 6C32 9.31371 34.6863 12 38 12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41C12 44.3137 9.31371 47 6 47C2.68629 47 0 44.3137 0 41C0 37.6863 2.68629 35 6 35C9.31371 35 12 37.6863 12 41Z",
    fill: "#9088DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 46C8.76142 46 11 43.7614 11 41C11 38.2386 8.76142 36 6 36C3.23858 36 1 38.2386 1 41C1 43.7614 3.23858 46 6 46ZM6 47C9.31371 47 12 44.3137 12 41C12 37.6863 9.31371 35 6 35C2.68629 35 0 37.6863 0 41C0 44.3137 2.68629 47 6 47Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionalSplitPreview);
export default __webpack_public_path__ + "static/media/ConditionalSplitPreview.713f92bf052f6458f3bf31d84ddcff3c.svg";
export { ForwardRef as ReactComponent };